import {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import {Button} from 'reactstrap'

import RemoveModal from '../../../../../shared/components/Modals/RemoveModal/RemoveModal.jsx'

import api from '../../../../../api.js'
import connectModal from '../../../../../shared/components/Modals/connect.js'
import {generate} from '../../../../routes.js'
import {isAdmin} from '../../../../../shared/services/userService.js'

import AdministrationMenu from "../AdministrationMenu/AdministrationMenu.jsx"
import CardCol from "../../../../../shared/components/Styled/Card/CardCol.jsx"
import CardRow from "../../../../../shared/components/Styled/Card/CardRow.jsx"
import FreelanceMenu from "../FreelanceMenu/FreelanceMenu.jsx"

import './LeftMenu.scss'

class LeftMenu extends Component {
  static propTypes = {
    className: PropTypes.string,
    link: PropTypes.object.isRequired,
    user: PropTypes.object,
    freelance: PropTypes.object,
  }

  static defaultProps = {
    link: {
      menu: 'freelance-profile',
      parameters: {},
      search: {},
    }
  }

  refreshUser = async (user) => {
    const freelance = (await api.freelances.getOne({freelance: this.props.freelance.id})).data
    this.props.refresh({
      user: {...this.props.user, ...user},
      freelance: {...this.props.freelance, ...freelance},
    })
  }

  remove = () => {
    this.props.openRemoveModal({
      user: this.props.user,
      onSoftDelete: (user) => this.refreshUser(user),
      onHardDelete: () => {
        window.location = generate({
          name: 'search',
          search: {
            universe: this.props.currentUniverseId
          }
        })
      },
    })
  }

  restore = async () => {
    const restoredUser = (await api.users.restore({
      user: this.props.user.id,
    })).data
    await this.refreshUser(restoredUser)
  }

  render() {
    const {user, link, isAdmin, isMobile} = this.props
    return (
      <div className="level2-menu-column">
        <CardRow direction="column" align="center" className="level2-menu-header">
          <CardCol className={'level2-menu-fullname'}>
            {user?.fullname ?? ''}
          </CardCol>
          <CardCol>
            <Link
              className="btn btn-primary link-profile mt-2 mb-0"
              to={generate({name: `${link.menu}.show`, parameters: link.parameters, search: link.search})}
            >
              Voir le profil
            </Link>
          </CardCol>
        </CardRow>

        <div className="level2-menu-column-content">
          <AdministrationMenu
            link={link}
            isAdmin={isAdmin}
          />

          <FreelanceMenu
            isMobile={isMobile}
            link={link}
            isAdmin={isAdmin}
            freelance={this.props.freelance}
            refresh={this.props.refresh}
          />

          {isAdmin ?
            <div className="menu-content text-center">
              <Button
                className="link-profile my-2 w-100"
                color={user?.gray ? 'primary' : 'danger'}
                onClick={user?.gray ? this.restore : this.remove}
              >
                {user?.gray ? 'Restaurer' : 'Supprimer'} l'utilisateur
              </Button>
            </div> : ''
          }
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  })
)(connectModal({RemoveModal}, LeftMenu))
